import * as React from 'react';
import { Link } from 'react-router-dom';

class Sidebar extends React.Component {
  render() {
    return (
      <div className="sidebar">
        <Link to="/about">About</Link>
        <Link to="/experience">Experience</Link>
        <Link to="/book">Book</Link>
        {/* <Link to="/hobbies">Hobbies</Link> */}
      </div>
    );
  }
}
 
export default Sidebar;